import { TmTransportError } from '@/core/error/transport/tmTransportError'

export class TmTransportNoResponseError extends TmTransportError {
  public name = 'TmTransportNoResponseError'
}
